import React, {Component} from 'react';
import Loader from "../layout/Loader";
class Uploading extends Component {
    render() {
        return (<Loader />);
    }
}
export default Uploading;